import { jsx as Z } from "react/jsx-runtime";
const h = (a) => /* @__PURE__ */ Z(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...a,
    children: /* @__PURE__ */ Z(
      "path",
      {
        fill: "currentColor",
        d: "m18.287 16.93-1.414 1.414 4.745 4.744 1.414-1.414-4.745-4.744ZM21.617 40.938l-4.744 4.745 1.414 1.414 4.745-4.744-1.415-1.415ZM32.957 46.989h-2v11.028h2V46.99ZM42.296 40.94l-1.414 1.413 4.744 4.745 1.414-1.414-4.744-4.745ZM57.96 31.014H46.933v2h11.029v-2ZM45.626 16.93l-4.744 4.745 1.414 1.414 4.745-4.745-1.415-1.414ZM32.957 6.01h-2v11.028h2V6.01ZM33.957 26.54v-6.338h-4v6.337c1.29-.47 2.71-.47 4 0ZM26.483 30.014h-6.338v4h6.338a5.85 5.85 0 0 1 0-4ZM36.078 27.892a5.816 5.816 0 0 1 1.165 1.664l3.367-3.366-2.829-2.829-3.366 3.366c.602.28 1.166.669 1.663 1.165ZM27.836 27.892a5.816 5.816 0 0 1 1.663-1.165l-3.366-3.366-2.828 2.829 3.366 3.366a5.816 5.816 0 0 1 1.165-1.664ZM37.432 30.014a5.85 5.85 0 0 1 0 4h6.337v-4h-6.337ZM36.078 36.135a5.817 5.817 0 0 1-1.663 1.165l3.366 3.366 2.829-2.828-3.367-3.367a5.814 5.814 0 0 1-1.165 1.664ZM27.836 36.135a5.814 5.814 0 0 1-1.165-1.664l-3.366 3.367 2.828 2.828L29.5 37.3a5.819 5.819 0 0 1-1.663-1.165ZM29.957 37.488v6.338h4v-6.338a5.85 5.85 0 0 1-4 0ZM16.982 31.014H5.953v2h11.029v-2ZM31.957 30.38c.436 0 .847.17 1.155.479.309.308.478.718.478 1.155 0 .436-.17.846-.478 1.155a1.623 1.623 0 0 1-1.155.478c-.436 0-.846-.17-1.155-.478a1.623 1.623 0 0 1-.478-1.155c0-.437.17-.847.478-1.155a1.622 1.622 0 0 1 1.155-.479Zm0-2a3.633 3.633 0 1 0 0 7.267 3.633 3.633 0 0 0 0-7.267Z"
      }
    )
  }
);
export {
  h as Lasers
};
